import { Tabs } from "antd";

import { useNavigate } from "react-router-dom";
import { useQuery } from "~/Hooks/useQuery";
import { InternationalClients } from "./InternationalClients/InternationalClients";
import { LocalClients } from "./LocalClients/LocalClients";
import { MainContent } from "./MainContent/MainContent";

export const OurClients = () => {
  const navigate = useNavigate();
  const query = useQuery();

  const items = [
    {
      label: "Overview",
      key: "ourClientsMainContent",
      children: <MainContent />,
    },
    {
      label: "Local Clients",
      key: "localClients",
      children: <LocalClients />,
    },
    {
      label: "International Clients",
      key: "internationalClients",
      children: <InternationalClients />,
    },
  ];

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || items[0].key}
      items={items}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
  );
};
